module.exports = __webpack_public_path__ + "workspace/static/img/accessMgmtOne.73be04f.png";